import React from 'react';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import {
  getIngIdStockNumber,
  getIngNameByIngId,
  getIngredientTypeName,
  isNullOrUndefined,
  padZeros,
} from 'utils/Global';

import './ProteinVariantStdIngCard.scss';

const ProteinVariantStdIngCard = (props) => {
  const { ingredient } = props;

  return (
    <div
      id={`proteinvariantstdingcard-container-${ingredient.id}`}
      className="standard-ingredient-card-container"
    >
      <div
        id={`proteinvariantstdingcard-icon-container-${ingredient.id}`}
        className="standard-ingredient-card-icon"
      >
        <RMSvgIcon
          id="proteinvariantstdingcard-svg-ingtubes-icon"
          name="IngredientTubes"
          fill="#414042"
          height="1.75rem"
          width="1.75rem"
        />
      </div>
      <div
        id={`proteinvariantstdingcard-content-${ingredient.id}`}
        className="standard-ingredient-card-content"
      >
        <div
          id={`proteinvariantstdingcard-title-${ingredient.id}`}
          className="standard-ingredient-card-content-protein-name"
        >
          {ingredient.ingredientStock
            ? getIngNameByIngId(ingredient.ingredientStock.ingredientId)
            : null}
        </div>
        <div
          id={`proteinvariantstdingcard-type-${ingredient.id}`}
          className="standard-ingredient-card-content-protein-type"
        >
          {isNullOrUndefined(ingredient)
            ? null
            : `${getIngredientTypeName(ingredient.ingredientIngredientTypeId)}`}
        </div>
        <div
          id={`proteinvariantstdingcard-concentration-${ingredient.id}`}
          className="standard-ingredient-card-content-protein-conc"
        >
          Conc.{' '}
          {isNullOrUndefined(ingredient.concentration)
            ? 0
            : ingredient.concentration.toFixed(2)}{' '}
          {ingredient.ph ? `pH ${ingredient.ph}` : ''}
        </div>

        {ingredient.ingredientStock.isBuffer ? (
          <>
            <div
              id={`proteinvariantstdingcard-stockbuffer-${ingredient.id}`}
              className="standard-ingredient-card-content-protein-info"
            >
              Stock {ingredient.ingredientStock.stockConcentration}{' '}
              {ingredient.ingredientStock.concentrationUnits}, pH{' '}
              {ingredient.ingredientStock.stockPh}{' '}
              {getIngIdStockNumber(
                ingredient.ingredientStock.ingredientId,
                ingredient.ingredientStock.stockNumber,
              )}
            </div>
            {ingredient.highPhingredientStock && (
              <div
                id={`proteinvariantstdingcard-stockhighph-${ingredient.id}`}
                className="standard-ingredient-card-content-protein-info"
              >
                Stock{' '}
                {!isNullOrUndefined(ingredient.highPhingredientStock) &&
                  ingredient.highPhingredientStock.stockConcentration}{' '}
                {!isNullOrUndefined(ingredient.highPhingredientStock) &&
                  ingredient.highPhingredientStock.concentrationUnits}
                , pH {ingredient.highPhingredientStock?.stockPh}{' '}
                {!isNullOrUndefined(ingredient.highPhingredientStock) &&
                  getIngIdStockNumber(
                    ingredient.highPhingredientStock.ingredientId,
                    ingredient.highPhingredientStock.stockNumber,
                  )}
              </div>
            )}
          </>
        ) : (
          <div
            id={`proteinvariantstdingcard-stocknonbuffer-${ingredient.id}`}
            className="standard-ingredient-card-content-protein-info"
          >
            Stock {padZeros(ingredient.ingredientStock.stockNumber, 3)}{' '}
            {ingredient.ingredientStock.stockConcentration}{' '}
            {ingredient.ingredientStock.concentrationUnits}{' '}
            {getIngIdStockNumber(
              ingredient.ingredientStock.ingredientId,
              ingredient.ingredientStock.stockNumber,
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProteinVariantStdIngCard;
